export function getCategoryName(categories, categoryId) {
  const category = categories.find((c) => c.id === categoryId);
  return category ? category.name : "Unknown";
}


export function getCategoryColor(categories, categoryId) {
  const category = categories.find((c) => c.id === categoryId);
  return category?.color || "#3B82F6";
}
